import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { checkParams } from "../../../src/util/Util";

const ResetPassword = (props) => {
  const [successLoad, setSuccessLoad] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [passVisible1, setPassVisible1] = useState(false);
  const [passVisible2, setPassVisible2] = useState(false);
  const [errorPassword, setErrorPassword] = useState("");
  let navigate = useNavigate();
  let { verify_mail } = useParams();

  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);
  }, [props]);

  const [passAllValid, setPassAllValid] = useState(false);
  const [charLengthValid, setCharLengthValid] = useState(false);
  const [hasLetter, setHasLetter] = useState(false);
  const [hasNum, setHasNum] = useState(false);
  const [hasSpecChar, setHasSpecChar] = useState(false);

  const sweepThroughTickers = (value) => {
    setErrorPassword("");
    setCharLengthValid(checkParams(value, "charLength"));
    setHasLetter(checkParams(value, "hasLetter"));
    setHasNum(checkParams(value, "hasNum"));
    setHasSpecChar(checkParams(value, "hasSpecChar"));
    setPassword1(value);
    if (
      checkParams(value, "charLength") &&
      checkParams(value, "hasLetter") &&
      checkParams(value, "hasNum") &&
      checkParams(value, "hasSpecChar")
    ) {
      setPassAllValid(true);
    } else {
      setPassAllValid(false);
    }
  };

  const handleReset = () => {
    setErrorPassword("");
    /* if (!checkParams(password1, "password")) {
      setErrorPassword("Invalid password!");
      return false;
    }
    if (!checkParams(password2, "password")) {
      setErrorPassword("Invalid password!");
      return false;
    } */
    if (password1 !== password2) {
      setErrorPassword("Passwords are not the same.");
      return false;
    }

    if (passAllValid) {
      axios
      .post(window.ajaxLink + "user/update-password", {
        email: verify_mail,
        password: password2,
      })
      .then((res) => {
        if (res.data.responseCode === 200) {
          setSuccessLoad("Password has been successfully reset. Please login with your new password.");
        }
      })
      .catch((error) => {
        if (error.response.data.responseCode === 417) {
          setErrorPassword(error.response.data.errorData);
        }
      });
    }
  };
  return (
    <div>
      <div className="memberRegisterContainer forgot_contain">
        <div className="memberRegisterHolder web_login_holder">
          <div className="sign_title">Reset Password</div>
          <div className="info_row_holder">
            <div className="form_title">Enter your password</div>
            <div className="relative_holder">
              <input
                type={passVisible1 ? "text" : "password"}
                className="gray_inputs gray_inputs_login"
                onChange={(e) => sweepThroughTickers(e.currentTarget.value)}
              />
              <div className="eye_show" onClick={() => setPassVisible1(!passVisible1)}>
                {passVisible1 && <div className="crossed_eye"></div>}
              </div>
            </div>
            {password1.length > 0 && (!charLengthValid || !hasLetter || !hasNum || !hasSpecChar) && (
              <>
                <div className="reg_pass_check_contain">
                  <div className={"reg_pass_ticker" + (charLengthValid ? " rpass_true" : "")}></div>
                  Must be at least 8 characters
                </div>
                <div className="reg_pass_check_contain">
                  <div className={"reg_pass_ticker" + (hasLetter ? " rpass_true" : "")}></div>
                  Minimum 1 Letter
                </div>
                <div className="reg_pass_check_contain">
                  <div className={"reg_pass_ticker" + (hasNum ? " rpass_true" : "")}></div>
                  Minimum 1 Number
                </div>
                <div className="reg_pass_check_contain">
                  <div className={"reg_pass_ticker" + (hasSpecChar ? " rpass_true" : "")}></div>
                  Minimum 1 Special character
                </div>
              </>
            )}
            <div className="form_title">Confirm Password</div>
            <div className="relative_holder">
              <input
                type={passVisible2 ? "text" : "password"}
                className="gray_inputs gray_inputs_login"
                onChange={(e) => setPassword2(e.currentTarget.value)}
              />
              <div className="eye_show" onClick={() => setPassVisible2(!passVisible2)}>
                {passVisible2 && <div className="crossed_eye"></div>}
              </div>
            </div>
            <>{errorPassword && <div className="email_error_msg">{errorPassword}</div>}</>
          </div>
          <div className="bottomLoginPadding">
            <div className="signNewButton signNew_login" onClick={() => handleReset()}>
              Submit
            </div>
          </div>
        </div>
      </div>
      {successLoad && (
        <div className="dlt_wrapper">
          <div className="dbl_place_on_page">
            <div className="dlt_surround">
              <div className="dlt_title">Reset Confirmation</div>
              <div className="dlt_description">{successLoad}</div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn" onClick={() => navigate("/")}>
                  OK
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
